<template>
    <trimoz-switch
        :label="formattedLabel(
            metadata[`description${this.upperLocale}`],
            required
        )"
        :aria-label="setAriaLabel"
        :name="metadata.name"
        :checked="setValue"
        :data-meta-id="metadata.id"
        :id="metadata.name"
        @update:checked="emitValue"
    />
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import TrimozSwitch from '@/components/inputs/TrimozSwitch';

export default {
    name: 'unknown-father',
    mixins: [formRules, inputHelpers],
    components: {
        TrimozSwitch,
    },
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: [String, Boolean, Number], required: false, default: '' },
        placeholder: { type: String, required: false, default: '' },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),

        setValue() {
            return this.value ? 1 : 0;
        },
        setAriaLabel() {
            // Add a trailing period to force the narrator to pause
            const value = (this.value ? this.$i18n.t('base.yes') : this.$i18n.t('base.no')) + '. ';
            return (this.required ? '* ' : '') + this.metadata[`description${this.upperLocale}`] + ', ' + value;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
